/**
 * Emoji-hasznalat: melyik jeleket hasznalja valaki, es milyen gyakran.
 *
 * Ebbol all ossze a valaszto "Gyakori" sora. Nem egy elore kivalasztott
 * keszlet, hanem a SAJAT szokasod: aki naponta tiz 🐶-t kuld, annak az legyen
 * elol, nem a 🚀.
 */
/** Ennyi jel fer a "Gyakori" sorba (harom sor a het oszlopos racsban). */
export const FREQUENT_EMOJI_LIMIT = 21;
/**
 * Egy jel sulyanak felezesi ideje, napokban.
 *
 * A puszta darabszam beragadna: aki tavaly ezer 🎄-t kuldott, annak az orokre
 * elol maradna. A felezessel a regi szokas lassan elhalvanyul, az uj pedig
 * nehany hasznalat utan feljon - egy honap mulva a regi hasznalat mar csak
 * fel annyit er.
 */
export const EMOJI_USAGE_HALF_LIFE_DAYS = 30;
/**
 * Egyetlen beepitett emoji-e a grafema?
 *
 * Az `RGI_Emoji` tulajdonsag a teljes jel-sorozatot nezi: a zaszlo, a
 * borszines kez, a 👨‍👩‍👧 csalad es az 1️⃣ billentyu is EGY jelnek szamit. A
 * sima `Extended_Pictographic` ezzel szemben a szoveges ©-t vagy a ‼-t is
 * emojinak venne.
 *
 * A `v` jelzot szovegbol epitjuk, mert a TS celszintje a literalt meg nem
 * ismeri; a futtatokornyezet (Node 20+, mai bongeszok) igen.
 */
const SINGLE_EMOJI = new RegExp('^\\p{RGI_Emoji}$', 'v');
/** Egyedi emoji hivatkozasa a szovegben - ugyanaz az alak, amit a kliens rajzol. */
const CUSTOM_EMOJI = /:([a-z0-9][a-z0-9_-]{0,30}):/g;
let segmenter;
/**
 * Az uzenetben hasznalt emojik, ISMETLES NELKUL.
 *
 * Egy uzenetben a 😂😂😂 egy hasznalat, nem harom: kulonben egyetlen
 * lelkes uzenet eldontene, mi kerul a sor elejere.
 *
 * Az egyedi emojiknal csak a `:nev:` alakot adjuk vissza; hogy letezik-e ilyen
 * nevu emoji, azt a hivo donti el (a `10:30:00` is illeszkedik a mintara).
 */
export function extractEmoji(text) {
    const builtin = new Set();
    const custom = new Set();
    if (!text)
        return { builtin: [], custom: [] };
    segmenter ??= new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    for (const { segment } of segmenter.segment(text)) {
        // Gyors kiszures: az ASCII grafema sosem emoji (a billentyus 1️⃣ sem ASCII).
        if (segment.charCodeAt(0) < 0x80 && segment.length === 1)
            continue;
        if (SINGLE_EMOJI.test(segment))
            builtin.add(segment);
    }
    for (const match of text.matchAll(CUSTOM_EMOJI))
        custom.add(`:${match[1]}:`);
    return { builtin: [...builtin], custom: [...custom] };
}
//# sourceMappingURL=emoji-usage.js.map